import React, { useState, useCallback } from 'react'
import ProgressBar from './ProgressBar';
import useSections from '../hooks/useSections';

function SectionSelect({ collection, setCollection }) {
    const { sections } = useSections();
    const enabled = sections.filter(s => s.enabled !== false);
    return (
        <select title=" الفئة " id="coll" value={collection} onChange={e => setCollection(e.target.value)}>
            {enabled.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
        </select>
    );
}

const UploadForm = () => {
    const [files, setFiles] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentFile, setCurrentFile] = useState(null);
    const [error, setError] = useState(null);
    const [collection, setCollection] = useState('images');
    const [completedCount, setCompletedCount] = useState(0);

    const fileType = ['image/jpeg', 'image/png', 'image/webp'];

    const handleChange = (e) => {
        const selected = Array.from(e.target.files || []);
        const valid = selected.filter(f => fileType.includes(f.type));
        const invalid = selected.length - valid.length;

        if (invalid > 0) {
            setError(`تم تجاهل ${invalid} ملف غير مدعوم. الأنواع المسموحة: png/jpeg/webp`);
        } else {
            setError(null);
        }

        if (valid.length > 0) {
            setFiles(valid);
            setCurrentIndex(0);
            setCompletedCount(0);
            setCurrentFile(valid[0]);
        }
    };

    const handleFileComplete = useCallback(() => {
        setCompletedCount(prev => prev + 1);
        const nextIndex = currentIndex + 1;
        if (nextIndex < files.length) {
            setCurrentIndex(nextIndex);
            setCurrentFile(files[nextIndex]);
        } else {
            setCurrentFile(null);
        }
    }, [currentIndex, files]);

    const setFileNull = useCallback((val) => {
        if (val === null && currentIndex + 1 < files.length) {
            // لا تمسح — سيتم الانتقال للملف التالي عبر onComplete
        } else if (val === null && currentIndex + 1 >= files.length) {
            setCurrentFile(null);
        }
    }, [currentIndex, files.length]);

    const total = files.length;
    const isUploading = currentFile !== null;

    return (
        <>
            <div className="input-group mb-3 btn btn-info btn-file">
                {total > 1 ? `رفع ${total} صورة ..` : 'رفع صورة ..'}
                <input type="file" className="form-control" id="inputGroupFile02" name="upfile" 
                    onChange={handleChange} multiple accept="image/jpeg,image/png,image/webp" />
            </div>             
            <div className="output">
                {error && <div className='text-danger mb-2'>{error}</div>}
                {isUploading && total > 1 && (
                    <div className='text-info mb-1'>
                        جاري رفع {currentIndex + 1} من {total} — {files[currentIndex]?.name}
                    </div>
                )}
                {isUploading && total === 1 && (
                    <div className='text-success'>{files[0]?.name}</div>
                )}
                {currentFile && (
                    <ProgressBar 
                        file={currentFile} 
                        setFile={setFileNull} 
                        collection={collection}
                        onComplete={handleFileComplete}
                    />
                )}
                {!isUploading && completedCount > 0 && (
                    <div className='text-success mt-2'>
                        ✅ تم رفع {completedCount} {completedCount === 1 ? 'صورة' : 'صورة'} بنجاح
                    </div>
                )}
            </div>

            <br></br>
            <SectionSelect collection={collection} setCollection={setCollection} />
        </>
    )
}

export default UploadForm
